import Popup from 'reactjs-popup';
import React from 'react';
import { PhotoPopupProps } from '../../types/PhotoBook/interfaces';
import { Container, Close } from './style';

const PhotoModal: React.FC<PhotoPopupProps> = ({ trigger, photoURL }) => {
  const modalOverlayStyle = {
    backgroundColor: 'rgba(0,0,0,0.2)',
  };

  return (
    <Popup
      trigger={<div style={{ height: '90%', width: '90%' }}>{trigger}</div>}
      modal
      closeOnDocumentClick
      overlayStyle={modalOverlayStyle}
    >
      {(close: any) => (
        <Container>
          <img src={photoURL} alt="fotografia da pesquisa" />
          <Close onClick={close}>X</Close>
        </Container>
      )}
    </Popup>
  );
};

export default PhotoModal;
